import { PLAYED_SOUND } from "../action_list";

export const played_sound = () => dispatch => {
    dispatch({type:PLAYED_SOUND});
}